import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/cards',
        name: 'cards',
        meta: { sideMenuLabel: "Carte" },
        component: () => import("./views/cards.vue")
    },
    {
        path: '/cards/:identifier',
        name: 'cardsDetail',
        component: () => import("./views/cardsDetail.vue")
    },
];

export default routes;